import { z } from 'zod';
import { OnboardingFormFields } from '@Types/types.ts';
import { birthDateSchema } from '@Schema/birthDateSchema.ts';
import { getConditionalNationalityScheme } from '@Components/inputs/NationalityInput.tsx';
import { getConditionalPassportScheme } from '@Components/inputs/PassportInput.tsx';
import { getConditionalNationalIdInputSchema } from '@Components/inputs/NationalIdInput.tsx';
import { IdentityFormTypes } from '@Components/Identity/IdentityFormTypeSwitcher';
import { getConditionalSsnSchema } from '@Schema/ssnSchema.ts';

export const getCombinedScheme = (formType: IdentityFormTypes, owner?: boolean) => {
  const isNonUs = formType === IdentityFormTypes.nonUs;
  const isUs = formType === IdentityFormTypes.us;
  return z.object({
    ...birthDateSchema.shape,
    ...getConditionalNationalityScheme(isNonUs).shape,
    ...getConditionalPassportScheme(isNonUs).shape,
    ...getConditionalNationalIdInputSchema(isNonUs).shape,
    ...getConditionalSsnSchema(isUs).shape,
    [OnboardingFormFields.IDENTITY_NON_US_AGREEMENT_A]: z.boolean().refine((value) => {
      if (formType === IdentityFormTypes.nonUs) {
        return value;
      }
      return true;
    }),
    [OnboardingFormFields.IDENTITY_NON_US_AGREEMENT_B]: z.boolean().refine((value) => {
      if (formType === IdentityFormTypes.nonUs && !owner) {
        return value;
      }
      return true;
    }),
    formType: z.number().optional(),
  });
};
